/* eslint no-eval: 0 */
import { combineReducers } from "redux";

import {
  permissionsConstants
} from "../actions/permissions";

export const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false
  },
  permissions: [],
  userPermissions: []
};

const defaultCompanyState = {
  status: {
    started: false,
    error: false,
    ended: false
  },
  companies: []
};

function companySettingsList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultCompanyState : state;
  switch (type) {
  case permissionsConstants.CLEAR_SEARCHED_COMPANY_SETTINGS:
    return {
      ...defaultS,
      preSearchedCompany: null,
      companies: defaultS.preSearchedCompany
        ? defaultS.preSearchedCompany
        : defaultS.companies
    };
  case permissionsConstants.LOAD_SEARCHED_COMPANY_SETTINGS_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      preSearchedCompany: payload.companiesList,
      companies:
          payload.data.items.length > 0
            ? payload.data.items
            : payload.companiesList
    };
  case permissionsConstants.LOAD_COMPANY_SETTINGS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      companies: payload.isAppend ? defaultS.companies : []
    };
  case permissionsConstants.LOAD_COMPANY_SETTINGS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      },
      companies: []
    };
  case permissionsConstants.LOAD_COMPANY_SETTINGS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      companies: payload.isAppend
        ? defaultS.companies.concat(payload.result)
        : payload.result,
      hasMoreItems: payload.hasMoreItems
    };

  default:
    return defaultS;
  }
}

export function permissionClient(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_COMPANY_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      permissions: []
    };
  case permissionsConstants.GET_SETTINGS_COMPANY_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      },
      permissions: []
    };
  case permissionsConstants.GET_SETTINGS_COMPANY_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      companyId: payload.itemId,
      permissions: payload.currentPermissions,
      originalPermissions: payload.originalPermissions
    };

  default:
    return defaultS;
  }
}

function permissionUser(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_USER_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      userPermissions: []
    };
  case permissionsConstants.GET_SETTINGS_USER_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      },
      userPermissions: []
    };
  case permissionsConstants.GET_SETTINGS_USER_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      companyId: payload.itemId,
      userId: payload.userId,
      userPermissions: payload.currentPermissions,
      originalPermissions: payload.originalPermissions
    };

  default:
    return defaultS;
  }
}

function permissionOtherUsers(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_OTHER_USERS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      otherUsersPermissions: []
    };
  case permissionsConstants.GET_SETTINGS_OTHER_USERS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      },
      otherUsersPermissions: []
    };
  case permissionsConstants.GET_SETTINGS_OTHER_USERS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      companyId: payload.itemId,
      userId: payload.userId,
      otherUsersPermissions: payload.currentPermissions,
      originalPermissions: payload.originalPermissions
    };

  default:
    return defaultS;
  }
}

function permissionClientsList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? null : state;
  if (type === permissionsConstants.GET_SETTINGS_COMPANIES_SUCCESS) {
    /** TODO */

    return {
      ...defaultS,
      listClientsSettings: payload.listClientsSettings
    };
  } 
  return defaultS;
  
}

function isPermissionsSaving(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.SAVE_PERMISSIONS_START:
    return true;
  case permissionsConstants.SAVE_PERMISSIONS_SUCCESS:
  case permissionsConstants.SAVE_PERMISSIONS_ERROR:
    return false;
  default:
    return defaultS;
  }
}

function isPermissionsSaved(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.SAVE_PERMISSIONS_SUCCESS:
    return true;
  case permissionsConstants.SAVE_PERMISSIONS_START:
  case permissionsConstants.SAVE_PERMISSIONS_ERROR:
    return false;
  default:
    return defaultS;
  }
}

function isPermissionsError(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.SAVE_PERMISSIONS_ERROR:
    return true;
  case permissionsConstants.SAVE_PERMISSIONS_START:
  case permissionsConstants.SAVE_PERMISSIONS_SUCCESS:
    return false;
  default:
    return defaultS;
  }
}

function isGettingPermissionsCompanies(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_COMPANIES_START:
    return true;
  case permissionsConstants.GET_SETTINGS_COMPANIES_SUCCESS:
    return false;
  default:
    return defaultS;
  }
}

function isLoadingSettings(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_COMPANY_SUCCESS:
  case permissionsConstants.GET_SETTINGS_COMPANY_ERROR:
    return false;
  case permissionsConstants.GET_SETTINGS_COMPANY_START:
    return true;
  default:
    return defaultS;
  }
}

function isLoadingUserSettings(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_USER_SUCCESS:
  case permissionsConstants.GET_SETTINGS_USER_ERROR:
    return false;
  case permissionsConstants.GET_SETTINGS_USER_START:
    return true;
  default:
    return defaultS;
  }
}

function isLoadingOtherUsersSettings(state, { type }) {
  let defaultS = typeof state === "undefined" ? false : state;
  switch (type) {
  case permissionsConstants.GET_SETTINGS_OTHER_USERS_SUCCESS:
  case permissionsConstants.GET_SETTINGS_OTHER_USERS_ERROR:
    return false;
  case permissionsConstants.GET_SETTINGS_OTHER_USERS_START:
    return true;
  default:
    return defaultS;
  }
}

export const currentPermissions = combineReducers({
  permissionClient,
  permissionClientsList,
  permissionUser,
  permissionOtherUsers,
  companySettingsList,
  isPermissionsError,
  isPermissionsSaved,
  isPermissionsSaving,
  isLoadingSettings,
  isLoadingUserSettings,
  isLoadingOtherUsersSettings,
  isGettingPermissionsCompanies
});

export default currentPermissions;
